import intl from 'react-intl-universal'

export function ModalController(root) {
  this.intl = intl
  this.store = {}
  root.$on('MODAL', (sender, action) => {
    this.store[action.type] = action.payload
    this.type = action.type
    if (action.type === 'CLOSE') {
      return this.close()
    }
    this.visible = true
  })

  this.close = () => {
    this.visible = false
  }

  this.handleClick = (e) => {
    // kinda hacky
    if (e.target.className.indexOf('overlay') < 0) {
      return
    }
    this.visible = false
    if (typeof this.onclick === 'function') {
      this.onclick(e)
    }
  }
}

export default ['$rootScope', ModalController]
